import Button from "../components/Button";
import PageHero from "../components/PageHero";

export function NotFound() {
  return (
    <>
      <PageHero
        eyebrow="404"
        title="That page has moved."
        copy="The link may be out of date, but the work still has a next step."
      />
      <section id="content" className="section-space bg-white text-center">
        <div className="container">
          <Button to="/">Return home</Button>
        </div>
      </section>
    </>
  );
}

export default NotFound;
